import {
  LINK_OPTION_COPY_REACTION_FAILURE,
  LINK_OPTIONS_CLEAR,
  LINK_OPTIONS_CLOSE,
  LINK_OPTIONS_OPEN,
} from '@Pages/RetroSynthesis/LinkOption/constants';

export const initialState = {
  targetRect: undefined,
  step: undefined,
  error: null,
};

export default function reducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case LINK_OPTIONS_OPEN:
      const { targetRect, step } = payload;
      return {
        ...state,
        targetRect,
        step,
        error: null,
      };
    case LINK_OPTIONS_CLOSE:
      return { ...initialState };
    case LINK_OPTIONS_CLEAR:
      return { ...initialState };
    case LINK_OPTION_COPY_REACTION_FAILURE:
      Logger.error('RT Copy reaction error: ', payload);
      return { ...initialState, error: payload };
    default:
      return state;
  }
}
